import React, { Component } from 'react';

import { isAfterDataFimInscricaoEDataFimPagamento } from '../../helper/ContextHelper';

import Grid from '@material-ui/core/Grid';

import Table, { DataTableLineTotals as Totals } from '../../components/Table/Table';

import { percentMask, numberFormat } from '../../helper/MaskHelper';

import { 
    ButtonNewTabEscolasPorUf,
    ButtonNewTabEscolasPorUfAndStatus,
} from '../Buttons/ButtonsNewTab';

export class DadosInscricaoUF extends Component {
    sumUfs = () => this.props.ufs.length;
    sumEscolas = () => this.props.ufs.reduce((total, uf) => total + uf.qtdEscolasTotal, 0);
    sumEscolasInscritas = () => this.props.ufs.reduce((total, uf) => total + uf.qtdEscolasInscritasTotal, 0);
    sumEscolasAguardandoPagamento = () => this.props.ufs.reduce((total, uf) => total + uf.qtdEscolasAguardandoPagamentoTotal, 0);
    sumEscolasInscritasPorcentagem = () => this.props.ufs.reduce((total, uf) => total + uf.qtdEscolasInscritasPorcentagemTotal, 0);
    sumMunicipios = () => this.props.ufs.reduce((total, uf) => total + uf.qtdMunicipiosTotal, 0);
    sumMunicipiosInscritos = () => this.props.ufs.reduce((total, uf) => total + uf.qtdMunicipiosInscritosTotal, 0);
    sumMunicipiosInscritosPorcentagem = () => this.props.ufs.reduce((total, uf) => total + uf.qtdMunicipiosInscritosPorcentagemTotal, 0);
    sumAlunosPrevistos = () => this.props.ufs.reduce((total, uf) => total + uf.qtdAlunosPrevistosTotal, 0);
    sumAlunosPrevistosMirim1 = () => this.props.ufs.reduce((total, uf) => total + uf.qtdAlunosPrevistosMirim1, 0);
    sumAlunosPrevistosMirim2 = () => this.props.ufs.reduce((total, uf) => total + uf.qtdAlunosPrevistosMirim2, 0);

    newTabEscolasPorUf = (qtd, uf) => <ButtonNewTabEscolasPorUf qtd={numberFormat(qtd)} uf={uf} />
    newTabEscolasPorUfAndStatus = (qtd, uf, status) => <ButtonNewTabEscolasPorUfAndStatus qtd={numberFormat(qtd)} uf={uf} status={status} />

    render () {
        const columns = [
            { label: 'UF', name: 'nmUf', func: null, key: true, width: '9', orderLabel: 'asc', },
            { label: 'Total de Escolas', name: 'qtdEscolasTotal', func: this.newTabEscolasPorUf, key: false, width: '9', },
            { label: 'Total de Escolas Inscritas', name: 'qtdEscolasInscritasTotal', func: (qtd, uf) => this.newTabEscolasPorUfAndStatus(qtd, uf, "CONCLUIDA"), key: false, width: '9', },
            { label: 'Total de Escolas Aguardando Pagamento', name: 'qtdEscolasAguardandoPagamentoTotal', func: (qtd, uf) => this.newTabEscolasPorUfAndStatus(qtd, uf, "AGUARDANDO_PAGAMENTO"), key: false, width: '9', hidden: isAfterDataFimInscricaoEDataFimPagamento(this.props.contexts), },
            { label: '% de Escolas Inscritas', name: 'qtdEscolasInscritasPorcentagemTotal', func: percentMask, key: false, width: '9', },
            { label: 'Total de Municipios', name: 'qtdMunicipiosTotal', func: numberFormat, key: false, width: '9', },
            { label: 'Total de Municipios Inscritos', name: 'qtdMunicipiosInscritosTotal', func: numberFormat, key: false, width: '9', },
            { label: '% de Municipios Inscritos', name: 'qtdMunicipiosInscritosPorcentagemTotal', func: percentMask, key: false, width: '9', },
            { label: 'Mirim 1 - Alunos Inscritos', name: 'qtdAlunosPrevistosMirim1', func: numberFormat, key: false, width: '9', },
            { label: 'Mirim 2 - Alunos Inscritos', name: 'qtdAlunosPrevistosMirim2', func: numberFormat, key: false, width: '9', },
            { label: 'Total de Alunos Inscritos', name: 'qtdAlunosPrevistosTotal', func: numberFormat, key: false, width: '9', },
        ];
        
        const actions = [];

        const totals = [
            { column: 0, value: numberFormat(this.sumUfs()), width: '9', },
            { column: 1, value: numberFormat(this.sumEscolas()), width: '9', },
            { column: 2, value: numberFormat(this.sumEscolasInscritas()), width: '9', },
            { column: 3, value: numberFormat(this.sumEscolasAguardandoPagamento()), width: '9', hidden: isAfterDataFimInscricaoEDataFimPagamento(this.props.contexts), },
            { column: 4, value: percentMask(this.sumEscolasInscritasPorcentagem() / this.sumUfs()), width: '9', },
            { column: 5, value: numberFormat(this.sumMunicipios()), width: '9', },
            { column: 6, value: numberFormat(this.sumMunicipiosInscritos()), width: '9', },
            { column: 7, value: percentMask(this.sumMunicipiosInscritosPorcentagem() / this.sumUfs()), width: '9', },
            { column: 8, value: numberFormat(this.sumAlunosPrevistosMirim1()), width: '9', },
            { column: 9, value: numberFormat(this.sumAlunosPrevistosMirim2()), width: '9', },
            { column: 10, value: numberFormat(this.sumAlunosPrevistos()), width: '9', },
        ];

        return (
            <Grid container spacing={3} style={{ marginTop: this.props.marginTop ?? 8 }}>
                <Grid item xs={12}>
                    <Table              
                        columns={columns}
                        tableData={this.props.ufs}
                        actions={actions}
                        page={null}
                        rowsPerPage={null}
                        sort={null}
                        fixedHeader={true}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Totals lineData={totals} columns={columns} />
                </Grid>
            </Grid>
        )
    }
}

export default DadosInscricaoUF;